import React, { FC } from 'react';
import styles from './LandingPageStep.scss';
import { LandingPageStepContent } from './components/LandingPageStepContent';
import { LandingPageStepContentAssetsDesktop } from './components/LandingPageStepAssetsDesktop';
import { useIsMobile } from 'hooks/useIsMobile';
import { LandingPageStepContentAssetsMobile } from './components/LandingPageStepAssetsMobile';

export const LandingPageStep: FC = () => {
  const isMobile = useIsMobile();

  return (
    <div className={styles.landingPageStep}>
      <div className={styles.landingPageStepBackground} />
      <LandingPageStepContent />
      {isMobile ? <LandingPageStepContentAssetsMobile /> : <LandingPageStepContentAssetsDesktop />}
    </div>
  );
};
